<template>
    <div>
        <vs-dialog width="550px" not-center v-model="active">
            <template #header>
            <h4 class="not-margin">
                Conciliar pago en línea Santander
            </h4>
            </template>
            <div class="con-content">
                <div>
                    ¿Esta seguro de conciliar el pago?
                </div>
            </div>

            <template #footer>
            <div class="con-footer" style="display: flex; justify-content: space-between;">
                <vs-button danger @click="active = false">
                Cancelar
                </vs-button>
                <vs-button success @click="postConciliarSantander(info.referencia)">
                Aceptar
                </vs-button>
            </div>
            </template>
        </vs-dialog>
    </div>
</template>

<script>
import cobranza from '../../../../../api/requests/cobranza-persona'
export default {
    props:[
      'value',
      'row',
      'info'
    ],
    data(){
        return{
            active: false
        }
    },
    methods:{
        async postConciliarSantander(referencia){
            const loading = this.$vs.loading()
            try{
                const formData = new FormData()
                formData.append('referencia', referencia)
                const {data: response} = await cobranza.getRespuestaSigem(formData)
                this.active = false
                if(response.status == 'no_conciliada'){
                    loading.close()
                    this.$vs.notification({
                        progress: 'auto',
                        color: 'danger',
                        position: null,
                        title: response.message
                    })
                }
                if(response.status == 'conciliada'){
                    loading.close()
                    this.$vs.notification({
                        progress: 'auto',
                        color: 'success',
                        position: null,
                        title: response.message
                    })
                }
                if(response.status == 'pago_declinado'){
                    loading.close()
                    this.$vs.notification({
                        progress: 'auto',
                        color: 'warn',
                        position: null,
                        title: response.message
                    })
                }
                
      		    this.$emit('refreshTable',true)
            }catch(error){
      		    this.$emit('refreshTable',true)
                this.active = false
                loading.close()
                this.$vs.notification({
                    progress: 'auto',
                    color: 'warn',
                    position: null,
                    duration: 'none',
                    title: 'Pago conciliado con error de facturación' ,
                    text: error.response.data.message
                })
            }
        }
    },
    watch: {
        value (val) {
            this.active = val
        },    
        async active (val) {
            if (!val){
                this.$emit('input', val);
            }
        }
    }
}
</script>